import { Component, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-session-popup',
  standalone: true,
  imports: [],
  templateUrl: './session-popup.component.html',
  styleUrl: './session-popup.component.scss',
})
export class SessionPopup {
  private authService = inject(AuthService);

  /** 'warning' = 1 min before, 'expired' = at expiry, null = hidden */
  readonly popupState = this.authService.popupState;

  /** Countdown seconds for expired popup (10 → 0) */
  readonly countdown = this.authService.expiryCountdown;

  /** Prevents double-click on keep session button */
  readonly refreshing = signal(false);

  onKeepSession(): void {
    if (this.refreshing()) return;
    this.refreshing.set(true);
    this.authService
      .refreshSession()
      .pipe(finalize(() => this.refreshing.set(false)))
      .subscribe();
  }

  onDismissWarning(): void {
    this.authService.dismissWarning();
  }

  onExpiredOk(): void {
    this.authService.redirectToLogin();
  }
}
